import { memo, useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { getGrooverText } from '../libs/GrooverTextRepository'
import { REGISTER_PAGE_MAX_WIDTH } from '../enums/HardCodedValues'
import { getRegisterSkeletonStillLoadingDelayMs, markRegisterSkeletonShown } from '../helpers/isRegisterPagePath'
import '../register-boot-skeleton.css'

const STEP_COUNT = 5
const CLOSED_ROW_COUNT = 4

const RegisterPageSkeleton = () => {
  const [showStillLoading, setShowStillLoading] = useState(false)

  useEffect(() => {
    markRegisterSkeletonShown()
    const timeoutId = window.setTimeout(() => setShowStillLoading(true), getRegisterSkeletonStillLoadingDelayMs())
    return () => window.clearTimeout(timeoutId)
  }, [])

  return (
    <Container
      className="register-skeleton-page"
      role="status"
      aria-busy="true"
      aria-live="polite"
      data-testid="register-page-skeleton"
    >
      <span className="register-skeleton-visually-hidden">{getGrooverText('common.loading')}</span>
      <div className="register-skeleton-toggle register-skeleton-bone" />
      <p
        className="register-skeleton-still-loading"
        data-visible={showStillLoading ? 'true' : undefined}
        aria-hidden={!showStillLoading}
      >
        {getGrooverText('registerPage.skeletonStillLoading')}
      </p>
      <div className="register-skeleton-steps">
        {Array.from({ length: STEP_COUNT }, (_, index) => (
          <div key={`register-skeleton-step-${index}`} className="register-skeleton-step">
            <div className="register-skeleton-circle register-skeleton-bone" />
            <div className="register-skeleton-label register-skeleton-bone" />
          </div>
        ))}
      </div>
      <div className="register-skeleton-activity register-skeleton-bone" />
      <div className="register-skeleton-card">
        <div className="register-skeleton-title register-skeleton-bone" />
        <div className="register-skeleton-field register-skeleton-bone" />
        <div className="register-skeleton-field register-skeleton-bone" />
        <div className="register-skeleton-field-short register-skeleton-bone" />
        <div className="register-skeleton-button register-skeleton-bone" />
      </div>
      {Array.from({ length: CLOSED_ROW_COUNT }, (_, index) => (
        <div key={`register-skeleton-row-${index}`} className="register-skeleton-row register-skeleton-bone" />
      ))}
    </Container>
  )
}

const Container = styled.div`
  max-width: ${REGISTER_PAGE_MAX_WIDTH};
  width: 100%;
`

export default memo(RegisterPageSkeleton)
